import type { ReviewPlyNote } from "@chessla/shared";
import { apiClient } from "@/shared/api/client";

export const fetchReviewPlyNoteAbortable = (
  gameId: string,
  ply: number,
  signal: AbortSignal,
): Promise<{ note: ReviewPlyNote | null }> =>
  apiClient<{ note: ReviewPlyNote | null }>(`/coach/games/${gameId}/notes/${ply}`, { signal });
